import XYZ from "ol/source/XYZ";

export const HERE_BASE_TILE_TEMPLATE = "https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8";
export const HERE_ATTRIBUTION = '&copy; <a href="https://www.here.com">HERE</a>';
export const BLANK_TILE_DATA_URI =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";

const HERE_LANGUAGE_BY_LOCALE = {
  en: "en",
  es: "es",
  ca: "ca",
  de: "de",
  fr: "fr",
  ru: "ru",
  pl: "pl",
};

export function normalizeHereLanguage(languageTag) {
  const raw = String(languageTag || "").trim().replace("_", "-");
  if (!raw) return "en";

  const lowered = raw.toLowerCase();
  if (HERE_LANGUAGE_BY_LOCALE[lowered]) return HERE_LANGUAGE_BY_LOCALE[lowered];

  const baseLanguage = lowered.split("-")[0];
  if (HERE_LANGUAGE_BY_LOCALE[baseLanguage]) return HERE_LANGUAGE_BY_LOCALE[baseLanguage];

  return "en";
}

function encodeQueryValue(value) {
  return encodeURIComponent(String(value || "").trim());
}

export function createBlankTileSource() {
  return new XYZ({ url: BLANK_TILE_DATA_URI, transition: 0 });
}

export function buildHereTileUrl({
  apiKey,
  language = "en",
  style = "lite.day",
  imageFormat = "png8",
  includeLanguage = true,
  disablePois = true,
}) {
  const normalizedKey = String(apiKey || "").trim();
  const normalizedLanguage = String(language || "en").trim() || "en";
  const queryParts = [
    `apiKey=${encodeQueryValue(normalizedKey)}`,
    `style=${encodeQueryValue(style)}`,
    "size=256",
    "ppi=100",
  ];

  if (includeLanguage) {
    queryParts.push(`lang=${encodeQueryValue(normalizedLanguage)}`);
  }
  if (disablePois) {
    queryParts.push(`features=${encodeQueryValue("pois:disabled")}`);
  }

  return (
    `${HERE_BASE_TILE_TEMPLATE.replace("/png8", `/${imageFormat}`)}?` +
    queryParts.join("&")
  );
}

export function createHereTileSource({
  apiKey,
  language = "en",
  style = "lite.day",
  imageFormat = "png8",
  includeLanguage = true,
  disablePois = true,
}) {
  const normalizedKey = String(apiKey || "").trim();
  if (!normalizedKey) return createBlankTileSource();

  return new XYZ({
    url: buildHereTileUrl({
      apiKey: normalizedKey,
      language,
      style,
      imageFormat,
      includeLanguage,
      disablePois,
    }),
    crossOrigin: "anonymous",
    attributions: HERE_ATTRIBUTION,
    maxZoom: 22,
    transition: 0,
  });
}
